module.exports = __webpack_public_path__ + "img/domestic-2018-awards-review.aaec5d76.jpg";